import { convertLinesToPanels, calculateCameraPosition } from 'util/threeDConverter';

import { Suspense } from 'react';

import { GlassDoorScene } from 'components/3D/GlassDoorScene';
import { useOptionContext } from 'context/OptionContext';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { MaterialType } from 'types/canvasTypes';

export default function Visualization3D() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const { lines, height, scale, materialType } = useOptionContext();
  
  // Get the return URL from query params, default to onboarding step 2
  const returnTo = searchParams.get('returnTo') || '/onboarding?step=2';

  // Convert 2D lines to 3D panels
  const panels = convertLinesToPanels(lines, height, scale);
  const cameraPosition = calculateCameraPosition(panels);

  if (lines.length === 0) {
    return (
      <div className="page" style={{ textAlign: 'center', padding: '50px' }}>
        <h1>{t('threeDVisualization')}</h1>
        <p>{t('noDesignToVisualize')}</p>
        <button className="edit-button" onClick={() => navigate(returnTo)}>
          {t('backToDesign')}
        </button>
      </div>
    );
  }

  return (
    <div className="visualization-page">
      {/* Header Controls */}
      <div className="overlay-panel overlay-panel--top flex-between">
        <h2 style={{ margin: 0 }}>{t('threeDVisualization')}</h2>
        <div className="section-header">
          <button className="edit-button" onClick={() => navigate(returnTo)}>
            {t('backToDesign')}
          </button>
        </div>
      </div>

      {/* Instructions */}
      <div className="overlay-panel overlay-panel--bottom">
        <div style={{ display: 'flex', gap: '30px', fontSize: '14px' }}>
          <span>🖱️ {t('rotateView')}</span>
          <span>🔍 {t('zoomView')}</span>
          <span>✋ {t('panView')}</span>
        </div>
      </div>

      {/* 3D Scene */}
      <Suspense
        fallback={
          <div className="flex-center" style={{ height: '100vh' }}>
            <h2>{t('loading')}</h2>
          </div>
        }
      >
        <GlassDoorScene
          panels={panels}
          materialType={materialType === MaterialType.Silver ? 'silver' : 'black'}
          cameraPosition={cameraPosition}
        />
      </Suspense>
    </div>
  );
}

